import type { FaireProductEntity } from "../../entity_types/product";

export const p_qgsjkj6h5e: FaireProductEntity = {
  token: "p_qgsjkj6h5e",
  type: "product",
  name: "Ionic Liquid Multiple Mineral",
  brandToken: "b_n34zp8ykn9",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/b39e033f5601539be51e0c50c2fdd81a76d2f5b72336f0bde6803e9516967394.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b2b481d4210ecbdf889885f2ccb8bf0a130aaf0bdc66f0d33b56a29d0287c73e.png",
    "https://cdn.faire.com/fastly/75816a2039044d5b66d3f0b249700267fbb193032b497977c10e311477a51341.jpeg",
    "https://cdn.faire.com/fastly/791965f85a62a245e5a5a3a00c50608caf9a50853ed7ca352c90f318a21dc1b1.jpeg",
  ],
  priceDollars: 13.85,
  description:
    "Eidon's multiple minerals are a complement of all essential and trace minerals necessary for good health in a silica base.In any multiple mineral formula, the key to its successful formulation lies in its mineral balance. Minerals work in a precise balance or ratio to one another. Too much or too little of even a trace mineral can decrease the effectiveness of a formula by limiting the availability of the other minerals. For people with well-balanced mineral ratios or those looking for a basic formula to supply a well-balanced broad spectrum of the most important mineral nutrients, Eidon's multiple mineral formulae can be an excellent addition to your nutritional program. Eidon's formulation reflects the most current understanding of optimal balance in a mineral formula. The macro minerals, calcium, and magnesium are kept in a 1:1 ratio to correct the erroneous dietary trend of high calcium and low magnesium intake. Easy on the stomach. Safe for all ages\tno color or scent.\n",
  tags: [],
  msrpDollars: 27.7,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:26:20.363Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
